import React from 'react';
import IncidentManager from '../../../incidentManager/IncidentManager';

export default function GroupIncidentsPage() {
  return <IncidentManager />;
}
